// ts-check
/** @jsx jsx */
import { Text } from '@bottlebooks/gatsby-theme-base';
import { TastingNoteButton } from '@bottlebooks/gatsby-theme-event/plugins/gatsby-plugin-tastingnotes/src';
import { jsx } from 'theme-ui';
import useSiteConfig from '../useSiteConfig';

export default function ProductCardTastingNoteAction({ product }) {
  const { getButtonProps, getIconProps, tastingNote } = TastingNoteButton.use({
    productId: product.productId,
  });
  // TODO move snipcart into separate theme and only check children + TastingNoteButton.
  // TODO also check if logged in?

  if (tastingNote) {
    return (
      <TastingNoteButton
        {...getButtonProps()}
        sx={{ display: 'flex', gap: 2, alignItems: 'center', marginBottom: 2 }}
        variant="text"
      >
        <TastingNoteButton.Icon
          {...getIconProps({ size: 'smallMedium' })}
          sx={{ flexShrink: 0 }}
        />
        {tastingNote.note && (
          <Text
            variant="small"
            sx={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {tastingNote.note}
          </Text>
        )}
      </TastingNoteButton>
    );
  }
  return (
    <TastingNoteButton.Large
      productId={product.productId}
      sx={{ marginBottom: 2 }}
    />
  );
}

export function useContent(product) {
  const { tastingNotesEnabled } = useSiteConfig();
  return {
    hasContent: tastingNotesEnabled,
  };
}

ProductCardTastingNoteAction.useContent = useContent;
